(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  var StickyHeader = function StickyHeader(options) {
    if ( options === void 0 ) options = {};

    this.selector = options.selector || '.elementor-location-header';
    this.hideThreshold = options.hideThreshold || 400;
    this.hiddenClass = options.hiddenClass || 'header-hidden';
    this.scrolledClass = options.scrolledClass || 'header-scrolled';

    this.header = document.querySelector(this.selector);
    this.lastScroll = 0;
    this.hasScrolled = false;

    if (!this.header) { return; }

    this._onScroll = this._handleScroll.bind(this);
    window.addEventListener('scroll', this._onScroll, { passive: true });
  };

  StickyHeader.prototype._handleScroll = function _handleScroll () {

    if (document.body.classList.contains('mobile-menu-open')) { return; }
    var current = window.scrollY;

    // Premier scroll : on active les effets
    if (!this.hasScrolled) {
      this.hasScrolled = true;
      this.header.classList.add(this.scrolledClass);
    }

    if (current <= 0) {
      this.header.classList.remove(this.hiddenClass);
      this.header.classList.remove(this.scrolledClass);
      this.hasScrolled = false;
      this.lastScroll = 0;
      return;
    }

    if (current > this.lastScroll && current > this.hideThreshold) {
      this.header.classList.add(this.hiddenClass);
    } else if (current < this.lastScroll) {
      this.header.classList.remove(this.hiddenClass);
    }

    this.lastScroll = current;
  };

  StickyHeader.prototype.destroy = function destroy () {
    window.removeEventListener('scroll', this._onScroll);
  };

  var MobileMenu = function MobileMenu(options) {
    if ( options === void 0 ) options = {};

    this.menuSelector = options.menuSelector|| '.cr-main-menu';
    this.toggleSelector = options.toggleSelector || '.cr-burger-toggle';
    this.activeClass  = options.activeClass || 'mobile-menu-open';
    this.overlayClass = 'cr-mobile-overlay';
    this.panelClass   = 'cr-mobile-panel';

    this.menu= document.querySelector(this.menuSelector);
    this.body= document.body;

    if (!this.menu) { return; }

    this._init();
  };

  MobileMenu.prototype._init = function _init () {
    this._createBurger();
    this._createPanel();
    this._createOverlay();
    this._bindEvents();
  };

  MobileMenu.prototype._createBurger = function _createBurger () {
    this.toggle = document.querySelector(this.toggleSelector);

    if (this.toggle) { return; }

    this.toggle = document.createElement('button');
    this.toggle.classList.add('cr-burger-toggle');
    this.toggle.setAttribute('aria-label', 'Ouvrir le menu');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" aria-hidden=\"true\" focusable=\"false\">\n      <path class=\"cercle\" d=\"M20,2c9.93,0,18,8.07,18,18s-8.07,18-18,18S2,29.93,2,20,10.07,2,20,2M20,0C8.95,0,0,8.95,0,20s8.95,20,20,20,20-8.95,20-20S31.05,0,20,0h0Z\"/>\n      <path class=\"trait-1\" d=\"M30.9,17.29H9.1c-.55,0-1-.45-1-1s.45-1,1-1h21.8c.55,0,1,.45,1,1s-.45,1-1,1Z\"/>\n      <path class=\"trait-2\" d=\"M30.9,24.71H9.1c-.55,0-1-.45-1-1s.45-1,1-1h21.8c.55,0,1,.45,1,1s-.45,1-1,1Z\"/>\n    </svg>";

    var target =
      document.querySelector('.elementor-sticky:not(.elementor-sticky__spacer)') ||
      document.querySelector('.elementor-location-header > [data-element_type="container"]') ||
      document.querySelector('.elementor-location-header') ||
      this.menu.parentElement;

    target.appendChild(this.toggle);
  };

  MobileMenu.prototype._createPanel = function _createPanel () {
    // Récupérer les items depuis le nav principal d'Elementor
    var source = this.menu.querySelector('.elementor-nav-menu--main .elementor-nav-menu');

    this.panel = document.createElement('nav');
    this.panel.classList.add(this.panelClass);
    this.panel.setAttribute('aria-label', 'Menu mobile');
    this.panel.setAttribute('aria-hidden', 'true');

    if (source) {
      var ul = source.cloneNode(true);
      // Nettoyer les attributs Elementor/SmartMenus
      ul.removeAttribute('data-smartmenus-id');
      ul.querySelectorAll('[tabindex="-1"]').forEach(function (el) { return el.removeAttribute('tabindex'); });
      this.panel.appendChild(ul);
    }

    this.body.appendChild(this.panel);
  };

  MobileMenu.prototype._createOverlay = function _createOverlay () {
    this.overlay = document.createElement('div');
    this.overlay.classList.add(this.overlayClass);
    this.body.appendChild(this.overlay);
  };

  MobileMenu.prototype._bindEvents = function _bindEvents () {
    this._onToggleClick= this._toggleMenu.bind(this);
    this._onOverlayClick = this._closeMenu.bind(this);
    this._onKeyDown    = this._handleKeyDown.bind(this);

    this.toggle.addEventListener('click', this._onToggleClick);
    this.overlay.addEventListener('click', this._onOverlayClick);
    document.addEventListener('keydown', this._onKeyDown);
  };

  MobileMenu.prototype._toggleMenu = function _toggleMenu () {
    this.body.classList.contains(this.activeClass)
      ? this._closeMenu()
      : this._openMenu();
  };

  MobileMenu.prototype._openMenu = function _openMenu () {
    this.body.classList.add(this.activeClass);
    this.toggle.setAttribute('aria-expanded', 'true');
    this.toggle.classList.add('is-active');
    this.panel.setAttribute('aria-hidden', 'false');
    this.body.style.overflow = 'hidden';
  };

  MobileMenu.prototype._closeMenu = function _closeMenu () {
    this.body.classList.remove(this.activeClass);
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.classList.remove('is-active');
    this.panel.setAttribute('aria-hidden', 'true');
    this.body.style.overflow = '';
  };

  MobileMenu.prototype._handleKeyDown = function _handleKeyDown (e) {
    if (e.key === 'Escape') { this._closeMenu(); }
  };

  MobileMenu.prototype.destroy = function destroy () {
    this.toggle.removeEventListener('click', this._onToggleClick);
    this.overlay.removeEventListener('click', this._onOverlayClick);
    document.removeEventListener('keydown', this._onKeyDown);
    this.overlay.remove();
    this.panel.remove();
    this.toggle.remove();
  };

  document.addEventListener('DOMContentLoaded', function () {
      new StickyHeader();
  });

  window.addEventListener('load', function () {
      new MobileMenu();
  });

}));
//# sourceMappingURL=clementriere.min.js.map
